export function trimFormValues<T>(data: T): T {
  if (typeof data === 'string') {
    return data.trim() as T;
  }

  if (Array.isArray(data)) {
    return data.map(trimFormValues) as T;
  }

  if (typeof data === 'object' && data !== null) {
    const result: Record<string, any> = {};
    for (const key in data) {
      result[key] = trimFormValues((data as any)[key]);
    }
    return result as T;
  }

  return data;
}

export const validateNotOnlySpaces = (value: any) =>
  value.trim().length > 0 || 'validation_notOnly_spaces_required';
